import { Dispatch, SetStateAction } from 'react'

import useSWR from 'swr'

import { apiDefaultFetcher } from '@/common/api/fetcher'
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '@/common/api/pagination'
import {
  ListOperatorsResponse,
  ListOperatorsVars,
  OperatorApiPath
} from '@/common/api/params/operator'
import { SearchConditionBase, SearchConditionParam, useSearchCondition } from '@/common/api/search'

export const useOperatorGetApi = ({ operator_id }: { operator_id: number }) => {
  const response = useOperatorListApi({})
  return {
    ...response,
    data: response.data ? response.data.find((op) => op.id === operator_id) : undefined
  }
}

export const fetchOperatorGetApiByEmail = async (email: string) => {
  const response = await apiDefaultFetcher<ListOperatorsResponse>([
    OperatorApiPath.LIST_OPERATORS,
    { email }
  ])
  return response.find((op) => op.email === email)
}

export const useOperatorListApi = (vars: ListOperatorsVars) => {
  return useSWR<ListOperatorsResponse, Response, [string, ListOperatorsVars]>(
    [OperatorApiPath.LIST_OPERATORS, vars],
    apiDefaultFetcher
  )
}

export const useOperatorSearchApi = (_condition: OperatorSearchCondition) => {
  return useSWR<ListOperatorsResponse, Response, [string, ListOperatorsVars]>([
    OperatorApiPath.LIST_OPERATORS,
    {}
  ])
}

export interface OperatorSearchCondition extends SearchConditionBase {
  keyword: string | null
}

const operatorSearchConditionParam: SearchConditionParam[] = [{ name: 'keyword', type: 'string' }]

export const OPERATOR_SEARCH_CONDITION_CLEAR: OperatorSearchCondition = {
  page: DEFAULT_PAGE,
  perPage: DEFAULT_PER_PAGE,
  keyword: null
}

export const useOperatorSearchCondition = (): [
  OperatorSearchCondition,
  Dispatch<SetStateAction<OperatorSearchCondition>>,
  (page: number) => void
] => {
  return useSearchCondition<OperatorSearchCondition>(operatorSearchConditionParam)
}
